import axiosInstance from '@/lib/axiosInstance';
import { AxiosPromise } from 'axios';
import {
  CheckHuggingFaceSupportParams,
  CheckHuggingFaceSupportRequest,
  CheckHuggingFaceSupportResponse,
  CreateDedicateInstanceRequest,
  CreateDedicateInstanceResponse,
  DeleteDedicateInstanceRequest,
  GetAvailablePricingResponse,
  GetInstanceRequest,
  GetInstanceResponse,
  GetInstancesRequest,
  GetInstancesResponse,
  GetUsageAndCosDedicateInstance,
  GetUsageAndCosDedicateInstanceByIdRequest,
  GetUsageAndCosDedicateInstancesRequest,
  GetUsageLogsDedicateInstanceLLMRequest,
  GetUsageLogsDedicateInstanceLLMResponse,
  RegenerateAPIDedicateInstanceRequest,
  RegenerateAPIDedicateInstanceResponse,
  SpecAndPricingInstanceGPU,
} from './type';

export const checkHuggingFaceSupport = async ({
  link,
  token,
}: CheckHuggingFaceSupportParams) => {
  const { data } = await axiosInstance.post<
    CheckHuggingFaceSupportResponse,
    AxiosPromise<CheckHuggingFaceSupportResponse>,
    CheckHuggingFaceSupportRequest
  >('/dedicate/check_model_repo', {
    model_repo: link,
    model_token: token,
  });
  return data;
};

export const getAvailablePricing = async () => {
  const { data } = await axiosInstance.post<
    GetAvailablePricingResponse,
    AxiosPromise<GetAvailablePricingResponse>
  >('/dedicate/get_available_pricing');
  return data;
};

export const createDedicateInstance = async (
  params: CreateDedicateInstanceRequest
) => {
  const { data } = await axiosInstance.post<
    CreateDedicateInstanceResponse,
    AxiosPromise<CreateDedicateInstanceResponse>,
    CreateDedicateInstanceRequest
  >('/dedicate/new', params);
  return data;
};

export const getDedicateInstances = async (params: GetInstancesRequest) => {
  const { data } = await axiosInstance.post<
    GetInstancesResponse,
    AxiosPromise<GetInstancesResponse>,
    GetInstancesRequest
  >('/dedicate/get_instance_info', params);
  return data;
};

export const getDedicateInstanceById = async (params: GetInstanceRequest) => {
  const { data } = await axiosInstance.post<
    GetInstanceResponse,
    AxiosPromise<GetInstanceResponse>,
    GetInstanceRequest
  >('/dedicate/get_single_instance_info', params);
  return data;
};

export const regenerateAPI = async (
  params: RegenerateAPIDedicateInstanceRequest
) => {
  const { data } = await axiosInstance.post<
    RegenerateAPIDedicateInstanceResponse,
    AxiosPromise<RegenerateAPIDedicateInstanceResponse>,
    RegenerateAPIDedicateInstanceRequest
  >('/dedicate/regenerate_api_key', params);
  return data;
};

export const deleteDedicateInstance = async (
  params: DeleteDedicateInstanceRequest
) => {
  const { data } = await axiosInstance.post('/dedicate/delete', params);
  return data;
};

export const getUsageAndCostDedicateInstance = async (
  params: GetUsageAndCosDedicateInstanceByIdRequest
) => {
  const { data } = await axiosInstance.post<
    GetUsageAndCosDedicateInstance,
    AxiosPromise<GetUsageAndCosDedicateInstance>,
    GetUsageAndCosDedicateInstanceByIdRequest
  >('/dedicate/get_usage_record_by_instance_id', params);
  return data;
};

export const getUsageAndCostDedicateInstances = async (
  params: GetUsageAndCosDedicateInstancesRequest) => {
  const { data } = await axiosInstance.post<
    GetUsageAndCosDedicateInstance[],
    AxiosPromise<GetUsageAndCosDedicateInstance[]>,
    GetUsageAndCosDedicateInstancesRequest
  >('/dedicate/get_usage_record', params);
  return data;
};

export const getGetUsageLogsDedicateInstance = async (
  params: GetUsageLogsDedicateInstanceLLMRequest
) => {
  const { data } = await axiosInstance.post<
    GetUsageLogsDedicateInstanceLLMResponse,
    AxiosPromise<GetUsageLogsDedicateInstanceLLMResponse>,
    GetUsageLogsDedicateInstanceLLMRequest
  >('/dedicate/get_usage_logs', params);
  return data;
};
